import Window from 'window-or-global'
import * as Sentry from '@sentry/browser'
import appConfig from '@/config'
import EventBus from '@/services/bus'
import { followRedirectStatus } from '@/services/api/interceptors/response'
import { getErrorEvent, decorateErrorMessage } from './helpers'

export const handleTimeout = error => {
  const { timeout } = appConfig.api
  const response = error.response
  const { data } = response
  let message = data && data.error_message
  if (!message) {
    message = `API timed out after ${timeout / 1000} seconds`
  }
  Window.console.error(message, error)
  error.message = decorateErrorMessage(response, message)
  EventBus.$emit('SHOW_ERROR_MESSAGE', getErrorEvent(response, message))
  if (appConfig.sentry.apiTimeout) {
    Sentry.captureMessage(error.message)
  }
  return Promise.reject(error)
}

export const handleNoResponse = error => {
  const verbed = 'returned no response'
  EventBus.$emit('SHOW_ERROR_MESSAGE', getErrorEvent(error, `API ${verbed}`))
  Window.console.error(`API ${verbed}`, error)
  error.message = decorateErrorMessage(error, verbed)
  if (appConfig.sentry.apiNoResponse) {
    Sentry.captureMessage(error.message)
  }
  return Promise.reject(error)
}

export const handleServerError = error => {
  const response = error.response
  const status = (response && response.status) || 500
  const { data } = response
  let message = data && data.error_message
  if (!message) {
    message = `API had a server error with status ${status}`
  }
  EventBus.$emit('SHOW_ERROR_MESSAGE', getErrorEvent(response, message))
  Window.console.error(message, error)
  error.message = decorateErrorMessage(response, message)
  if (appConfig.sentry.apiServerError) {
    Sentry.captureMessage(error.message)
  }
  return Promise.reject(error)
}

export const handleRedirect = error => {
  const { status } = error.response
  if (appConfig.sentry.apiRedirect) {
    Sentry.captureMessage(`${status}: ${error.message || 'redirect'}`)
  }
  return followRedirectStatus(error.response)
}

export const handleUnauthorized = error => {
  const response = error.response
  const { data, status } = response
  const message = (data && data.error_message) || 'unauthorized'
  const verbed = `had a request error with status ${status}: ${message}`

  Window.location = `${appConfig.auth.baseURL}/login?callback=${escape(encodeURI(Window.location))}`
  EventBus.$emit('SHOW_ERROR_MESSAGE', getErrorEvent(response, `API ${verbed}`))
  Window.console.error(`API ${verbed}`, error)
  error.message = decorateErrorMessage(response, verbed)
  if (appConfig.sentry.apiUnauthorized) {
    Sentry.captureMessage(error.message)
  }
  return Promise.reject(error)
}

export const handleForbidden = error => {
  const { data, status } = error.response
  const message = (data && data.error_message) || 'forbidden'
  const verbed = `had a request error with status ${status}: ${message}`
  EventBus.$emit('SHOW_ERROR_MESSAGE', getErrorEvent(error.response, `API ${verbed}`))
  EventBus.$emit('REFRESH_ACTIVE_PODCAST')
  Window.console.error(`API ${verbed}`, error)
  error.message = decorateErrorMessage(error.response, verbed)
  if (appConfig.sentry.apiForbidden) {
    Sentry.captureMessage(error.message)
  }
  return Promise.reject(error)
}

export const handleBadRequest = error => {
  const response = error.response
  const { data, status } = response
  let message = data && data.error_message
  if (!message) {
    message = `API had a request error with status ${status}`
  }
  EventBus.$emit('SHOW_ERROR_MESSAGE', getErrorEvent(response, message))
  Window.console.error(message, error)
  error.message = decorateErrorMessage(response, message)
  if (appConfig.sentry.apiBadRequest) {
    Sentry.captureMessage(error.message)
  }
  return Promise.reject(error)
}

export const handleNotFound = error => {
  const response = error.response
  const { data, status } = response
  let message = data && data.error_message
  if (!message) {
    message = `API had a request error with status ${status}`
  }
  // EventBus.$emit('SHOW_ERROR_MESSAGE', getErrorEvent(response, message))
  Window.console.error(message, error)
  error.message = decorateErrorMessage(response, message)
  if (appConfig.sentry.apiBadRequest) {
    Sentry.captureMessage(error.message)
  }
  return Promise.reject(error)
}
